import type { ArrayFieldDescriptionProps } from '@rjsf/utils'

export const ArrayFieldDescriptionTemplate = ({
  description
}: ArrayFieldDescriptionProps) => <p className={'mt-2'}>{description}</p>
